import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Card, CardHeader, CardMedia } from '@mui/material';
import { useTheme } from '@mui/styles';
import styles from './styles';
import CheckinsDetailedPhotoCard from '../checkinsDetailedPhotoCard';

const CheckinsPhotoCard = ({
  image,
}) => {
  const theme = useTheme();
  const classes = styles();
  const [detailedView, setDetailedView] = useState({
    open: false,
    data: {}
  });

  return (
    <>
      <Card className={classes.root} onClick={() => {
        setDetailedView({
          open: true,
          data: {
            image
          }
        });
      }}>
        <CardHeader
          titleTypographyProps={{ fontSize: 16, fontWeight: 'bold', noWrap: true, align: 'left' }}
          subheaderTypographyProps={{ align: 'left', fontSize: 14 }}
        />
        <CardMedia
          component="img"
          height="400px"
          image={image}
          sx={{ objectFit: 'contain', p: theme.spacing(1) }}
          loading={'lazy'}
        />
      </Card>
      {detailedView?.open && (
      <CheckinsDetailedPhotoCard
      open={detailedView?.open}
      handleClose={() => {
        setDetailedView({
          open: false,
          data: {}
        });
      }}
      data={detailedView?.data}
      />
      )}
    </>
  );
};

CheckinsPhotoCard.propTypes = {
  avatarLetter: PropTypes.string,
  title: PropTypes.string.isRequired,
  comment: PropTypes.string,
  image: PropTypes.string.isRequired,
  avatarColor: PropTypes.string,
  email: PropTypes.string,
  lastUpdate: PropTypes.string
};

export default CheckinsPhotoCard;
